import { createContext, useReducer, useEffect } from "react";
import { useParams } from "react-router-dom";
export const EditorValue = createContext(null);
export const EditorDisbatch = createContext(null);

const reducer = (state, action) => {
  if (action.type === "set") {
    return action.value;
  }
  if (action.type === "clear") {
    return null;
  } else {
    return state;
  }
};

export default function EditorContext({ children }) {
  const [state, dispatch] = useReducer(reducer, null);
  const { pageId } = useParams();

  useEffect(() => {
    dispatch({ type: "set", value: null });
  }, [pageId]);

  return (
    <EditorValue.Provider value={state}>
      <EditorDisbatch.Provider value={dispatch}>
        {children}
      </EditorDisbatch.Provider>
    </EditorValue.Provider>
  );
}
